var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"12","cols":"12","order":"1","order-lg":"1"}},[_c('b-card',[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }